export type CardMode = "open" | "close";

type Props = {
  readonly value: CardMode;
  readonly onChange: (m: CardMode) => void;
};

const OPTIONS: ReadonlyArray<{ id: CardMode; label: string }> = [
  { id: "open", label: "Increase" },
  { id: "close", label: "Reduce" },
];

export const ModeToggle = ({ value, onChange }: Props) => (
  <div
    role="radiogroup"
    aria-label="Card mode"
    className="inline-flex items-center gap-0.5 p-0.5 rounded-[var(--radius-sm)]"
    style={{ border: "1px solid var(--line-2)" }}
  >
    {OPTIONS.map((opt) => {
      const active = value === opt.id;
      return (
        <button
          key={opt.id}
          role="radio"
          aria-checked={active}
          type="button"
          onClick={() => onChange(opt.id)}
          className="px-3 py-1 rounded-[2px] font-mono text-[10px] tracking-[0.16em] uppercase transition-colors"
          style={{
            background: active ? "rgba(0,0,0,0.48)" : "transparent",
            color: active ? "var(--ink-1)" : "var(--ink-5)",
            fontWeight: 500,
          }}
        >
          {opt.label}
        </button>
      );
    })}
  </div>
);
